export function generateString(length: any) {
  let name = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    name += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return name;
}
